import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { Box, Typography, Grid, Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper ,Button} from "@mui/material";

import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Dialog,DialogTitle,DialogActions, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getVehicalTrackingDashboard, getCameraTrackingDashboard ,getVehicalTrackingTable} from "src/api/vehicles";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import Cameras from './Cameras';
import { ZoomIn, ZoomOut } from "@mui/icons-material";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Title, Tooltip, Legend, ChartDataLabels);


const DashboardSRMB = () => {
  const [vehicleData, setVehicleData] = useState([]);
  const [cameraData, setCameraData] = useState([]);
  const [fromDate, setFromDate] = useState(dayjs().startOf("day"));
  const [toDate, setToDate] = useState(dayjs().endOf("day"));
  const [selectedCard, setSelectedCard] = useState(null);
  const [vehicleDataTable, setVehicalDataTable] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");


  const [zoom, setZoom] = useState(1);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [dragging, setDragging] = useState(false);
    const [start, setStart] = useState({ x: 0, y: 0 });
  
    // Zoom In and Out
    const handleZoom = (delta) => {
      setZoom((prev) => Math.max(1, Math.min(prev + delta, 3))); // Limit zoom between 1x to 3x
    };
  
    // Handle Mouse Scroll for Zoom
    const handleWheel = (e) => {
      e.preventDefault();
      handleZoom(e.deltaY < 0 ? 0.1 : -0.1);
    };
  
    // Handle Mouse Drag
    const handleMouseDown = (e) => {
      setDragging(true);
      setStart({ x: e.clientX - position.x, y: e.clientY - position.y });
    };
  
    const handleMouseMove = (e) => {
      if (dragging) {
        setPosition({ x: e.clientX - start.x, y: e.clientY - start.y });
      }
    };
  
    const handleMouseUp = () => {
      setDragging(false);
    };
  

  useEffect(() => {
    const data = {
      from_date: dayjs(fromDate).format("YYYY-MM-DD HH:mm:ss"),
      to_date: dayjs(toDate).format("YYYY-MM-DD HH:mm:ss"),
    };

    getVehicalTrackingDashboard(data, (response) => {
      if (response.status === 200) {
        setVehicleData(response.data);
      } else {
        setVehicleData([]);
        console.error("Invalid vehicle tracking data:", response.data);
      }
    });

    getCameraTrackingDashboard(data, (response) => {
      if (response.status === 200) {
        setCameraData(response.data);
      } else {
        setCameraData([]);
        console.error("Invalid camera tracking data:", response.data);
      }
    });
  }, []);



  const fetchVehicleTracking = (fromDate, toDate, type) => {
    const body = {
      from_date: fromDate.format("YYYY-MM-DD HH:mm:ss"),
      to_date: toDate.format("YYYY-MM-DD HH:mm:ss"),
      type: type
    };

    getVehicalTrackingTable(body, (response) => {
      if (response.status === 200 && response.data) {
        setVehicalDataTable(response.data);
      }
    });
  };



  useEffect(() =>{
    // console.log("selected option",selectedCard);
    if(selectedCard === "Vehicle In"){
      let type = "in"
      fetchVehicleTracking(fromDate, toDate ,type);
    }
    if(selectedCard === "Vehicle Out"){
      let type = "out"
      fetchVehicleTracking(fromDate, toDate ,type);
    }

  },[selectedCard])

  const staticLabels = [
    "12 AM", "1 AM", "2 AM", "3 AM", "4 AM", "5 AM", "6 AM", "7 AM", "8 AM", "9 AM", "10 AM", "11 AM",
    "12 PM", "1 PM", "2 PM", "3 PM", "4 PM", "5 PM", "6 PM", "7 PM", "8 PM", "9 PM", "10 PM", "11 PM",
  ];

  const vehicleInData = new Array(staticLabels.length).fill(0);
  const vehicleOutData = new Array(staticLabels.length).fill(0);

  if (Array.isArray(vehicleData)) {
    vehicleData.forEach(({ Hour, VehicleInCount, VehicleOutCount }) => {
      const index = Hour;
      if (index >= 0 && index < vehicleInData.length) {
        vehicleInData[index] = VehicleInCount;
        vehicleOutData[index] = VehicleOutCount;
      }
    });
  }

  const graphData = {
    labels: staticLabels,
    datasets: [
      {
        label: "Vehicle In Count",
        data: vehicleInData,
        borderColor: "rgba(75, 192, 192, 1)",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        tension: 0.4,
        fill: true,
        pointBackgroundColor: "white",
        pointBorderColor: "white",
      },
      {
        label: "Vehicle Out Count",
        data: vehicleOutData,
        borderColor: "rgba(255, 99, 132, 1)",
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        tension: 0.4,
        fill: true,
        pointBackgroundColor: "white",
        pointBorderColor: "white",
      },
    ],
  };

  const cardDataArray = Object.keys(cameraData).map((key, index) => ({
    title: key === "ActiveDevices" ? "Active Cameras" : key === "InActiveDevices" ? "InActive Cameras" : key === "VehicleIn" ? "Vehicle In" : key === "VehicleOut" ? "Vehicle Out" : key,
    value: cameraData[key],
    color: ["#CCE7FF", "#E2EEFF", "#D4F3FF", "#E8FFD1"][index % 4],
  }));

  const navigate = useNavigate();

  const handleClick = (title) => {
    setSelectedCard(title);
  };


  const handleClickOpen = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage("");
    setZoom(1); // Reset zoom to original size
    setPosition({ x: 0, y: 0 }); // Reset position to original
  };

  const handleRest =() =>{
    setZoom(1); // Reset zoom to original size
    setPosition({ x: 0, y: 0 }); // Reset position to original
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        labels: { color: "white" }, // ✅ Legend text white
      },
      datalabels: {
        color: "white", // ✅ Data label color
        anchor: "end",
        align: "top",
        font: {
          weight: "bold",
          size: 11,
        },
      },
      title: {
        display: false,
      },
    },
    scales: {
      x: {
        ticks: { color: "white" }, // ✅ x-axis labels white
        grid: {
          color: "rgba(255, 255, 255, 0.2)", // ✅ gridlines semi-white
          borderColor: "white", // ✅ axis line white
        },
      },
      y: {
        ticks: { color: "white" }, // ✅ y-axis labels white
        grid: {
          color: "rgba(255, 255, 255, 0.2)",
          borderColor: "white",
        },
        title: {
          display: true,
          text: "Count",
          color: "white",
        },
      },
    },
  };


  return (
    <Box sx={{ p: 4,minHeight: "100vh" }}>
      <Typography variant="h5" gutterBottom>
        Dashboard
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Card sx={{ p: 2 }}>
            <Typography variant="h6">Vehicle Tracking</Typography>
            <Line data={graphData} options={options} plugins={[ChartDataLabels]} />
          </Card>
        </Grid>

        <Grid item xs={12} md={6} container spacing={2}>
          {cardDataArray.map((card, index) => (
            <Grid item xs={6} key={index +1}>
              <Card sx={{ textAlign: "center", backgroundColor: card.color, borderRadius: 2, boxShadow: 2 }}>
                <CardContent>
                  <Typography variant="h4" color="primary" onClick={() => handleClick(card.title)}>
                    {card.value}
                  </Typography>
                  <Typography variant="subtitle1" sx={{color:'#413e3eff'}}>{card.title}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Grid>
      {selectedCard && (
  <Box sx={{ mt: 4 }}>
     {selectedCard === "Active Cameras"  || selectedCard === "InActive Cameras"? (
            <Typography variant="h6"></Typography>

     ):(
      <Typography variant="h6">{selectedCard}</Typography>
     )}
    {selectedCard === "Active Cameras"  || selectedCard === "InActive Cameras"? (
    <Box sx={{ width: "100%" }}>
      {/* <Cameras  sx={{ width: "150%" }}/> */}
    </Box>
    ) : (
<TableContainer component={Paper} style={{ maxHeight: "400px", overflow: "auto" }}>
  <Table stickyHeader>
    <TableHead>
      <TableRow>
        <TableCell>S.No</TableCell>
        <TableCell>Camera Name</TableCell>
        {selectedCard === "Vehicle In" ? (
          <>
            <TableCell>Vehicle In Image</TableCell>
            <TableCell>Vehicle In Time</TableCell>
          </>
        ) : (
          <>
            <TableCell>Vehicle Out Image</TableCell>
            <TableCell>Vehicle Out Time</TableCell>
          </>
        )}
      </TableRow>
    </TableHead>
    <TableBody>
      {vehicleDataTable.map((vehicle, index) => (
        <TableRow key={index}>
          <TableCell>{index + 1}</TableCell>
          <TableCell>{vehicle.devicename}</TableCell>
          {selectedCard === "Vehicle In" ? (
            <>
              <TableCell>
                <img
                  src={vehicle.SnapshotUrl}
                  alt="Entry Snapshot"
                  style={{ width: "100px", height: "auto" }}
                  onClick={() => handleClickOpen(vehicle.SnapshotUrl)}

                />
              </TableCell>
              <TableCell>{vehicle.ObjectEntryOn ? vehicle.ObjectEntryOn.split(".")[0] : "N/A"}</TableCell>
            </>
          ) : (
            <>
              <TableCell>
                <img
                  src={vehicle.ExitSnapshotUrl}
                  alt="Exit Snapshot"
                  style={{ width: "100px", height: "auto" }}
                  onClick={() => handleClickOpen(vehicle.ExitSnapshotUrl)}

                />
              </TableCell>
              <TableCell>{vehicle.ObjectExitOn ? vehicle.ObjectExitOn.split(".")[0] : "N/A"}</TableCell>
              </>
          )}
        </TableRow>
      ))}
    </TableBody>

 <Dialog
      aria-labelledby="image-preview-dialog"
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle id="image-preview-dialog">Image Preview</DialogTitle>
      <DialogContent
        // sx={{
        //   display: "flex",
        //   justifyContent: "center",
        //   alignItems: "center",
        //   overflow: "hidden",
        //   position: "relative",
        //   cursor: dragging ? "grabbing" : "grab",
        // }}
        onWheel={handleWheel}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
      >

{selectedImage && (
            <Box component="img" src={selectedImage} alt="Snapshot" sx={{ width: "100%", maxHeight: "80vh", transform: `scale(${zoom}) translate(${position.x}px, ${position.y}px)`,
            transition: dragging ? "none" : "transform 0.3s ease-in-out"}} />
          )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between" }}>
        {/* Zoom Controls */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton onClick={() => handleZoom(-0.2)} disabled={zoom <= 1}>
            <ZoomOut />
          </IconButton>
          <Typography variant="body2">{Math.round(zoom * 100)}%</Typography>
          <IconButton onClick={() => handleZoom(0.2)} disabled={zoom >= 3}>
            <ZoomIn />
          </IconButton>
          <Button onClick={handleRest} variant="contained" color="primary">
          reset
        </Button>
        </Box>
        {/* Close Button */}
        <Button onClick={handleClose} color="error" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  </Table>
</TableContainer>


    )}
  </Box>
)}


    </Box>
  );
};

export default DashboardSRMB;